<template>
  <div
    class="
      bg-[#163982]
      text-lg
      p-2
      w-full
      text-left
      pl-6
      font-bold
      text-white
    "
  >
    {{title}}
  </div>
</template>

<script>
export default {
  props:["title"]
}
</script>